import type { ComponentProps } from 'react'

/**
 * Subtle fade + slide-up on load, like the live Webflow site. Pure CSS (the
 * .reveal animation in app.css), so it's in the static HTML and runs from the
 * first paint: starting it from JS after hydration made already-painted
 * content vanish and fade back in. Skipped for prefers-reduced-motion. Meant
 * for above-the-fold content; below the fold the animation would finish
 * before anyone scrolls to it.
 */
export function Reveal({
  delay = 0,
  className = '',
  style,
  ...props
}: ComponentProps<'div'> & { delay?: number }) {
  return (
    <div
      className={`reveal ${className}`}
      style={delay ? { animationDelay: `${delay}ms`, ...style } : style}
      {...props}
    />
  )
}
